import React from 'react';
import './Loading.css'; // Import styli

const Loading = ({info,styles}) => {
  return (
    <div className='loading-full-screen' style={styles}>
    <div className="loading-container">
      <div className="dot bounce1" />
      <div className="dot bounce2" />
      <div className="dot bounce3" />
   
    </div>
<h1>{info}</h1>
    </div>

  );
};

export default Loading;
